// 3rd party imports
import * as React from 'react';

// ui
import { UitkSecondaryButton, UitkButtonSize } from 'uitk-react-button';

interface CopyButtonProps {
  value: string;
}

export const CopyButton: React.FunctionComponent<CopyButtonProps> = ({ value }) => {
  const [copied, setCopied] = React.useState(false);

  const copyBtnOnClick = () => {
    navigator.clipboard.writeText(value);

    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  return (
    <UitkSecondaryButton className="CopyButton" onClick={() => copyBtnOnClick()} size={UitkButtonSize.LARGE}>
      {copied ? 'Copied' : 'Copy'}
    </UitkSecondaryButton>
  );
};
